import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M23.75 13a1.25 1.25 0 0 0-1.25-1.3h-8.94a.5.5 0 0 1-.28-.09c-.72-.51-1.48-1-2.22-1.43-2.79-1.72-4.49-2.9-4.49-4.86 0-2.24 2.21-2.57 3.52-2.57a4.53 4.53 0 0 1 3.08.76 2.7 2.7 0 0 1 .45 2v.29a1.25 1.25 0 0 0 2.5 0v-.27A4.9 4.9 0 0 0 15 1.76C14 .74 12.36.25 10.09.25c-3.66 0-6 2-6 5.07 0 2.77 1.89 4.51 4 5.92a.26.26 0 0 1 .1.28.25.25 0 0 1-.24.18H1.5a1.25 1.25 0 0 0 0 2.5h11a.27.27 0 0 1 .16.06 4.36 4.36 0 0 1 1.93 3.47c0 3.26-3.43 3.52-4.48 3.52-1.81 0-3.14-.41-3.83-1.17a3.4 3.4 0 0 1-.65-2.71 1.25 1.25 0 1 0-2.49-.24 5.75 5.75 0 0 0 1.26 4.62c1.2 1.33 3.12 2 5.69 2 4.17 0 7-2.42 7-6a6 6 0 0 0-.85-3.15.23.23 0 0 1 0-.25.23.23 0 0 1 .21-.13h6.05A1.25 1.25 0 0 0 23.75 13"
    }, null, -1)
  ]));
}
const EditorStrike = { render };
export {
  EditorStrike as default,
  render
};
//# sourceMappingURL=EditorStrike.svg.js.map
